import { useContext } from 'react';
import PropTypes from 'prop-types';
import getIn from 'immutable-less/transmute/getIn';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error untyped module
import ReferenceName from 'customer-data-reference-ui-components/name/ReferenceName';
// @ts-expect-error untyped module

// @ts-expect-error untyped module
import ReferenceResolversContext from 'reference-resolvers/ReferenceResolversContext';
import { useQuery } from 'data-fetching-client';
import * as PropertyValueTypes from 'automation-ui-flow-core/fields/PropertyValueTypes';
import PropertyValue from 'automation-ui-flow-core/fields/PropertyValue';
import Action from 'automation-ui-action-features/records/Action';
import StaticBranch from 'automation-ui-action-features/records/StaticBranch';
import { convertToAddonPropertyOption } from 'automation-ui-action-features/object-type-properties/propertyUtils';
import CRMPropertyValueTypes from 'automation-ui-flow-core/fields/CRMPropertyValueTypes';
import { getReferenceTypeFromProperty } from 'reference-resolvers-lite/utils/getReferenceTypeFromProperty';
import { isLoading, isError } from 'reference-resolvers-lite/Status';
import SkeletonText from 'automation-ui-core/components/SkeletonText';
import { useExternalOptions } from 'automation-ui-action-features/external-options/externalOptionsDecorator';
import getTokenParts from 'automation-ui-formula-editor/data-sources/utils/getTokenParts';
import { useGetDataSourceFromToObjectIdFromPropertyValue } from 'automation-ui-formula-editor/data-sources/hooks/useGetDataSourceFromToObjectIdFromPropertyValue';
import { GET_CRM_PROPERTY_DEFINITION } from 'automation-ui-formula-editor/data-sources/queries/getCRMPropertyDefinition';
import { getActionOutputsAsAddon } from 'automation-ui-action-features/data-passing/utils/actionOutputUtils';
import { useGetDataProperty } from 'automation-ui-formula-editor/data-sources/hooks/useGetDataProperty';
import usePropertyAsAddon from 'automation-ui-action-features/actions/static-branch/usePropertyAsAddon';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { ENFORCE_FIELD_LEVEL_PERMISSIONS } from 'automation-ui-action-features/constants/Gates';
import { useIsUngated } from 'automation-ui-core/hooks/authHooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const getBranchNameForEnrolledObject = ({
  branch,
  propertyAsOption,
  externalOptions,
  property,
  propertyTypeId,
  providedResolvers
}) => {
  const propertyValue = branch.getValue();
  if (propertyAsOption.valueType === CRMPropertyValueTypes.DATETIME) {
    return I18n.moment.userTz(Number(propertyValue)).format('LL');
  }
  if (propertyAsOption.valueType === CRMPropertyValueTypes.DATE) {
    return I18n.moment.utc(Number(propertyValue)).format('LL');
  }
  if (propertyAsOption.valueType === CRMPropertyValueTypes.BOOL) {
    return branch.value === 'true' ? I18n.text('automation-ui-action-features.boolean-labels.label-yes') : I18n.text('automation-ui-action-features.boolean-labels.label-no');
  }
  const referenceType = getReferenceTypeFromProperty(property, propertyTypeId);
  if (referenceType && externalOptions) {
    const {
      status,
      references: [reference] = []
    } = externalOptions;
    if (isLoading(status)) {
      return /*#__PURE__*/_jsx(SkeletonText, {});
    } else if (isError(status) || !reference) {
      return propertyValue && providedResolvers[referenceType] ?
      /*#__PURE__*/
      /* attempt to fetch resolver value from reference-resolvers instead of reference-resolvers-lite
      event enrollment data tokens & the contact persona need this */
      _jsx(ReferenceName, {
        id: propertyValue,
        referenceObjectType: referenceType,
        onError: () => propertyValue,
        onUnknown: () => propertyValue
      }) : propertyValue;
    }
    return reference.label;
  }
  const addonPropertyValue = propertyValue ? propertyAsOption.valueOptions.find(val => val.value === propertyValue) : null;
  if (addonPropertyValue) {
    return addonPropertyValue.text;
  }
  return undefined;
};
export const getBranchNameForFieldData = ({
  branch,
  inputValue,
  outputsByActionId,
  providedResolvers
}) => {
  const sourceActionId = inputValue.getTargetActionId();
  const outputsForSourceAction = outputsByActionId[sourceActionId];
  const dataKey = inputValue.getDataKey();
  const outputField = outputsForSourceAction && outputsForSourceAction.fields.find(field => field.value === dataKey);

  // Dev note: '' is the default value with no branch name defined in relaxed validation
  // Dev note 2: OutputField may be missing if user has deleted the action this branch references
  if (!outputsForSourceAction || !outputField || branch.value === '') {
    return undefined;
  }
  if (outputField && outputField.referencedObjectType && providedResolvers[outputField.referencedObjectType]) {
    return /*#__PURE__*/_jsx(ReferenceName, {
      id: branch.value,
      referenceObjectType: outputField.referencedObjectType
    });
  }
  if (outputField.valueType === CRMPropertyValueTypes.DATETIME) {
    return I18n.moment.userTz(Number(branch.value)).format('LL');
  }
  if (outputField.valueType === CRMPropertyValueTypes.DATE) {
    return I18n.moment.utc(Number(branch.value)).format('LL');
  }
  if (outputField.valueType === CRMPropertyValueTypes.ENUM || outputField.valueType === CRMPropertyValueTypes.BOOL) {
    const option = outputField.valueOptions.find(_option => _option.value === branch.value);
    if (option) return option.text;
  }
  return undefined;
};
export const getBranchNameWithOperator = (branchName, operator) => {
  let message;
  if (operator === 'IS_EQUAL_TO') {
    message = 'automation-ui-action-features.action-features.static-branch.branch-name.IS_EQUAL_TO';
  } else if (operator === 'IS_NOT_EQUAL_TO') {
    message = 'automation-ui-action-features.action-features.static-branch.branch-name.IS_NOT_EQUAL_TO';
  } else if (operator === 'IS_LESS_THAN') {
    message = 'automation-ui-action-features.action-features.static-branch.branch-name.IS_LESS_THAN';
  } else if (operator === 'IS_GREATER_THAN') {
    message = 'automation-ui-action-features.action-features.static-branch.branch-name.IS_GREATER_THAN';
  } else if (operator === 'IS_LESS_THAN_OR_EQUAL_TO') {
    message = 'automation-ui-action-features.action-features.static-branch.branch-name.IS_LESS_THAN_OR_EQUAL_TO';
  } else if (operator === 'IS_GREATER_THAN_OR_EQUAL_TO') {
    message = 'automation-ui-action-features.action-features.static-branch.branch-name.IS_GREATER_THAN_OR_EQUAL_TO';
  }
  return message ? /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: message,
    options: {
      branchName
    }
  }) : /*#__PURE__*/_jsx(_Fragment, {
    children: branchName
  });
};
const EMPTY_ARRAY = [];
function StaticBranchName({
  action,
  previousActionId,
  branch,
  branchIndex,
  propertyTypeId: flowObjectTypeId,
  getActionOutputsForTargetActionById
}) {
  var _data$dataSourceDefin;
  const metadata = action.getMetadata();
  const inputType = metadata.getInputType();
  const inputValue = metadata.getInputValue();
  const defaultPropertyTypeId = useGetDataSourceFromToObjectIdFromPropertyValue({
    propertyValue: new PropertyValue(metadata.getInputValue()),
    flowObjectTypeId
  }).toObjectTypeId;

  // could use this for all if you wired propertyDefinitionsAsAddon for OBJECT_PROPERTY inputs
  const {
    property: propertyForEnrollmentEventDataTokens
  } = usePropertyAsAddon({
    stagedAction: action,
    // we don't need this data for this use case but passing a new empty array would trigger a render loop
    propertyDefinitionsAsAddon: EMPTY_ARRAY,
    propertyDefinitionsAsAddonLoading: false,
    getActionOutputsForTargetActionById,
    previousActionId: previousActionId
  });
  let prefix = '';
  let propertyName;
  if (inputType === PropertyValueTypes.OBJECT_PROPERTY) {
    propertyName = inputValue.getPropertyName() || undefined;
    prefix = 'enrolled_object';
  } else if (inputType === PropertyValueTypes.FETCHED_OBJECT_PROPERTY || inputType === PropertyValueTypes.ENROLLMENT_EVENT_PROPERTY) {
    const dataTokenParts = getTokenParts(inputValue.getPropertyToken());
    propertyName = dataTokenParts.property;
    prefix = dataTokenParts.prefix;
  }

  // for inputType === ENROLLMENT_EVENT_PROPERTY, can only get the propertyTypeId
  // as eventTypeId from the data passing property
  const {
    data
  } = useGetDataProperty({
    prefix,
    property: propertyName
  });
  const dataSourceMetadata = (_data$dataSourceDefin = data === null || data === void 0 ? void 0 : data.dataSourceDefinition.metadata) !== null && _data$dataSourceDefin !== void 0 ? _data$dataSourceDefin : null;
  const eventEnrollmentPropertyTypeId = dataSourceMetadata && 'eventTypeId' in dataSourceMetadata ? dataSourceMetadata.eventTypeId : undefined;
  const propertyTypeId = eventEnrollmentPropertyTypeId || defaultPropertyTypeId;
  const propertyQuery = useQuery(GET_CRM_PROPERTY_DEFINITION, {
    skip: !propertyTypeId || !propertyName,
    variables: {
      objectType: propertyTypeId,
      property: propertyName
    }
  });
  const property = getIn(['getCRMPropertyDefinition', 'property'], propertyQuery.data);
  const actionId = action.getActionId();
  const outputsByActionId = getActionOutputsForTargetActionById(actionId || previousActionId, action.isNew());
  const externalOptions = useExternalOptions({
    property,
    propertyTypeId,
    externalOptionValue: branch.getValue()
  });
  const providedResolvers = useContext(ReferenceResolversContext);
  const enforceFlp = useIsUngated(ENFORCE_FIELD_LEVEL_PERMISSIONS);
  let branchName;
  if (inputType === PropertyValueTypes.OBJECT_PROPERTY) {
    let propertyAsOption;
    if (property) {
      propertyAsOption = convertToAddonPropertyOption({
        property,
        objectTypeId: propertyTypeId,
        enforceFlp,
        requiredPermissionLevel: 'read'
      });
    }
    if (propertyAsOption) {
      branchName = getBranchNameForEnrolledObject({
        branch,
        propertyAsOption,
        externalOptions,
        property: property,
        propertyTypeId,
        providedResolvers
      });
    }
  } else if (inputType === PropertyValueTypes.FETCHED_OBJECT_PROPERTY) {
    let propertyAsOption;
    if (property) {
      propertyAsOption = convertToAddonPropertyOption({
        property,
        objectTypeId: propertyTypeId,
        enforceFlp,
        requiredPermissionLevel: 'read'
      });
    }
    if (propertyAsOption) {
      branchName = getBranchNameForEnrolledObject({
        branch,
        propertyAsOption,
        externalOptions,
        property: property,
        propertyTypeId,
        providedResolvers
      });
    }
  } else if (inputType === PropertyValueTypes.ENROLLMENT_EVENT_PROPERTY) {
    let propertyAsOption;
    if (propertyForEnrollmentEventDataTokens) {
      propertyAsOption = convertToAddonPropertyOption({
        property: propertyForEnrollmentEventDataTokens,
        objectTypeId: propertyTypeId,
        enforceFlp,
        requiredPermissionLevel: 'read'
      });
    }
    if (propertyAsOption) {
      branchName = getBranchNameForEnrolledObject({
        branch,
        propertyAsOption,
        externalOptions,
        property: propertyForEnrollmentEventDataTokens,
        propertyTypeId,
        providedResolvers
      });
    }
  } else if (inputType === PropertyValueTypes.FIELD_DATA) {
    branchName = getBranchNameForFieldData({
      branch,
      inputValue,
      outputsByActionId: getActionOutputsAsAddon(outputsByActionId),
      providedResolvers
    });
  }
  if (branchName) {
    return getBranchNameWithOperator(branchName, branch.operator);
  }
  return /*#__PURE__*/_jsx("span", {
    children: branch.getBranchName() ? getBranchNameWithOperator(branch.getBranchName(), branch.operator) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-action-features.action-features.static-branch.branch-name.default",
      options: {
        branchNumber: branchIndex + 1
      }
    })
  });
}
StaticBranchName.propTypes = {
  action: PropTypes.instanceOf(Action).isRequired,
  previousActionId: PropTypes.string,
  branch: PropTypes.instanceOf(StaticBranch).isRequired,
  branchIndex: PropTypes.number.isRequired,
  getActionOutputsForTargetActionById: PropTypes.func.isRequired
};
export default StaticBranchName;